<template>
    <div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{path:'/dashboard'}">Inicio</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Grupos</li>
                        </ol>
                    </nav>
                </div>

                <div class="col-md-12">
                    <h3>Seleccione una sede</h3>
                </div>

                <div class="col-md-3" style="margin-bottom: 20px">
                    <router-link :to="{path:'/admin/grupos/Sevilla Este'}">
                        <div class="panel">
                            <div class="row">
                                <div class="col-md-12" style="padding-right: 0">
                                    <img src="img/logo.png" class="imgPanel img-fluid">
                                </div>
                            </div>
                            <p class="text-center txtPanel noselect">Sevilla Este</p>
                        </div>
                    </router-link>
                </div>

                <div class="col-md-3" style="margin-bottom: 20px">
                    <router-link :to="{path:'/admin/grupos/Santiponce'}">
                        <div class="panel">
                            <div class="row">
                                <div class="col-md-12" style="padding-right: 0">
                                    <img src="img/logo.png" class="imgPanel img-fluid">
                                </div>
                            </div>
                            <p class="text-center txtPanel noselect">Santiponce</p>
                        </div>
                    </router-link>
                </div>

<!--                <div class="col-md-3" style="margin-bottom: 20px">-->
<!--                    <router-link :to="{path:'/admin/grupos/Torreblanca'}">-->
<!--                        <div class="panel">-->
<!--                            <div class="row">-->
<!--                                <div class="col-md-12" style="padding-right: 0">-->
<!--                                    <img src="img/logo.png" class="imgPanel img-fluid">-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <p class="text-center txtPanel noselect">Torreblanca</p>-->
<!--                        </div>-->
<!--                    </router-link>-->
<!--                </div>-->

<!--                <div class="col-md-3" style="margin-bottom: 20px">-->
<!--                    <router-link :to="{path:'/admin/grupos/Castilleja Cuesta'}">-->
<!--                        <div class="panel">-->
<!--                            <div class="row">-->
<!--                                <div class="col-md-12" style="padding-right: 0">-->
<!--                                    <img src="img/logo.png" class="imgPanel img-fluid">-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <p class="text-center txtPanel noselect">Castilleja de la Cuesta</p>-->
<!--                        </div>-->
<!--                    </router-link>-->
<!--                </div>-->

            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import swal from 'sweetalert2'
    import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'


    export default {
        data() {
            return {
                type: this.$store.getters.type,
            };
        },
        directives: {
            'b-tooltip': BTooltipDirective
        },
        created() {

        },
        methods: {}

    };
</script>
<style scoped>

    .container-fluid {
        margin-top: 39px;
    }

    .panel {
        cursor: pointer;
        text-align: center;
        padding: 15px;
        border-radius: 5px;
        border: 1px solid #cdcdcd;
        background-color: #f1f1f1;
        transition: background-color 0.2s;
    }

    .panel:hover {
        background-color: #36305c;
    }

    .panel:hover p {
        color: #eee;
        text-shadow: 2px 2px 2px #000;
    }

    .txtPanel {
        font-size: 1.6em;
        margin-top: 30px;
        color: #111;
        text-shadow: 2px 2px 2px #eee;
    }

    .imgPanel {
        margin-top: 20px;
        padding: 12px;
        background-color: #fff;
        border-radius: 5%;
        max-width: 150px;
    }

    @media (max-width: 600px) {
        .imgPanel {
            max-width: 100px;
        }
    }

    .noselect {
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none;
        /* Non-prefixed version, currently
                                         supported by Chrome and Opera */
    }


</style>
